import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useEffect } from 'react';
import { rootRoute } from './__root';
import { useQuizStore } from '@/stores/quiz-store';
import { QuizContainer } from '@/components/quiz/quiz-container';

const searchSchema = z.object({
  variant: z.string().default('default'),
  ref: z.string().optional(),
});

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  validateSearch: searchSchema,
  component: LandingPage,
});

function LandingPage() {
  const { variant } = indexRoute.useSearch();
  const setVariant = useQuizStore((s) => s.setVariant);

  useEffect(() => {
    setVariant(variant);
  }, [variant, setVariant]);

  return (
    <div className="min-h-screen bg-background">
      <QuizContainer variant={variant} />
    </div>
  );
}
